import React from 'react';
import type { EventDto } from './types';
import { resolveThemePreset } from './themePresets';
import { EventBody } from './EventBody';
import { resolveEventSurface } from './surfaceContent';
import type { EventImageUrlResolver } from './EventBody';

export interface EventAnnouncementModalContentProps {
    readonly event: EventDto;
    readonly resolveImageUrls?: EventImageUrlResolver;
}

// The pop-up of a `kind: 'announcement'` event: subtitle + authored body only.
// The title comes from the modal chrome; there is no date, calendar or sign-off.
// Images (including a before/after grid) live in the authored body.
export const EventAnnouncementModalContent: React.FC<EventAnnouncementModalContentProps> = ({
    event,
    resolveImageUrls
}) => {
    const theme = resolveThemePreset(event.themePreset);
    const content = resolveEventSurface(event, 'modal');

    return (
        <div className="space-y-6">
            {(content.subtitleDoc || content.subtitle) && (
                <div className={`${theme.bg} rounded-xl p-5`}>
                    <EventBody bodyDoc={content.subtitleDoc} body={content.subtitle} />
                </div>
            )}

            <EventBody
                bodyDoc={event.bodyDoc}
                body={event.body}
                resolveImageUrls={resolveImageUrls}
            />
        </div>
    );
};

export default EventAnnouncementModalContent;
